import { Routes, Route } from 'react-router-dom';
import { HomePage, StatusPage, BlogsPage } from '@pages/index';

export function AppRoutes() {
  return (
    <>
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/status" element={<StatusPage />} />
        <Route path="/blogs" element={<BlogsPage />} />
      </Routes>
    </>
  );
}
